import React, { createContext, useContext, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "services/api"; // pakai POST karena API-nya butuh body
import { buildQueryString } from "utils/queryHelpers";

const DailyReportContext = createContext();

export const DailyReportProvider = ({ children }) => {
  //   const [filterOptions, setFilterOptions] = useState(() => {
  //     const today = new Date();
  //     const start = new Date(today.getFullYear(), today.getMonth(), 1);
  //     const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  //     return {
  //       filters: {
  //         start_date: start.toISOString().split("T")[0],
  //         end_date: end.toISOString().split("T")[0],
  //       },
  //     };
  //   });

  const [filterOptions, setFilterOptions] = useState(() => {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    
    // Format to local date string YYYY-MM-DD
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    return {
      filters: {
        start_date: formatDate(start),
        end_date: formatDate(end),
      },
    };
  });


  //   const fetchDailyReport = async (filterOptions) => {
  //     const response = await getRequest("/reservation/chart", {
  //       filter: {
  //         start_date: filterOptions.filters.start_date,
  //         end_date: filterOptions.filters.end_date,
  //       },
  //     });
  //     return response.data;
  //   };

  const fetchDailyReport = async () => {
    const queryString = buildQueryString({
        'filter[start_date]': filterOptions.filters.start_date,
        'filter[end_date]': filterOptions.filters.end_date,
      });
      
    const response = await getRequest(`/reservation/chart${queryString}`);

    if (response.success) {
      return response.data;
    }
    throw new Error("Failed to fetch daily report");
  };

//   const getStartEndOfMonth = (year, month) => {
//     const start = new Date(year, month, 1);
//     const end = new Date(year, month + 1, 0);
//     return {
//       start_date: start.toISOString().split("T")[0],
//       end_date: end.toISOString().split("T")[0],
//     };
//   };

  const formatDateLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getStartEndOfMonth = (year, month) => {
    const start = new Date(year, month, 1);
    const end = new Date(year, month + 1, 0);
    return {
      start_date: formatDateLocal(start),
      end_date: formatDateLocal(end),
    };
  };

  const changeMonth = (year, month) => {
    const { start_date, end_date } = getStartEndOfMonth(year, month);
    setFilterOptions({
      filters: {
        start_date,
        end_date,
      },
    });
  };


  const {
    data: dailyReport,
    isLoading: loadingDailyReport,
    error: errorDailyReport,
  } = useQuery({
    queryKey: [
      "dailyReport",
      filterOptions.filters.start_date,
      filterOptions.filters.end_date,
    ],
    queryFn: () => fetchDailyReport(filterOptions),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });

  return (
    <DailyReportContext.Provider
      value={{
        dailyReport,
        loadingDailyReport,
        errorDailyReport,
        setFilterOptions,
        filterOptions,
        changeMonth,
      }}
    >
      {children}
    </DailyReportContext.Provider>
  );
};

export const useDailyReport = () => {
  const context = useContext(DailyReportContext);
  if (!context) {
    throw new Error("useDailyReport must be used within a DailyReportProvider");
  }
  return context;
};
